import { Attachment } from '@nextforce/api'
import { isImageType, isVideoType } from 'file_folder_repository/util'
import React, { useLayoutEffect, useRef } from 'react'
import { StyleSheet, View } from 'react-native'
import Swiper from 'react-native-web-swiper'
import { ImageViewer } from './viewers/image'
import { VideoViewer } from './viewers/video'

interface Props {
  attachments: (Attachment | undefined)[] | undefined
  currentIndex: number | undefined
  setCurrentIndex: (index: number) => void
}

export function FileView({
  attachments,
  currentIndex,
  setCurrentIndex,
}: Props) {
  const swiperRef = useRef<Swiper>(null)

  useLayoutEffect(() => {
    if (currentIndex) {
      swiperRef.current?.goTo(currentIndex)
    }
  }, [currentIndex])

  if (!attachments) {
    return null
  }
  const renderPages = () =>
    attachments?.flatMap((attachment, index) => (
      <FileItemView
        key={attachment?.uri}
        item={attachment}
        index={index}
        currentIndex={currentIndex}
      />
    ))

  return (
    <View style={styles.container}>
      <Swiper ref={swiperRef} onIndexChanged={setCurrentIndex}>
        {renderPages()}
      </Swiper>
    </View>
  )
}

export const FileItemView = ({
  item,
  currentIndex,
  index,
}: {
  item: Attachment | undefined
  index?: number
  currentIndex?: number
}) => {
  let Viewer: React.JSX.Element

  if (item && isImageType(item?.mimeType)) {
    Viewer = <ImageViewer key={item.uri} source={{ uri: item.uri }} />
  } else if (item && isVideoType(item.mimeType)) {
    Viewer = (
      <VideoViewer
        key={item.uri}
        source={{ uri: item.uri }}
        shouldPlay={index === currentIndex}
      />
    )
  } else {
    return null
  }
  return Viewer
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'black',
  },
})
